import React, { FunctionComponent } from 'react';

import { Experiments } from '../../constants/experiments';
import { DonateButton } from '../DonateButton/DonateButton';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  return (
    <>
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        experiments={[
          // B2C_059 - donate to yourself v3
          // Can be removed when experiment has ended
          Experiments.b2c_059_donate_to_yourself_v3,
        ]}
        successType="StaticDonateButtonClick"
      />
      <Share successType="StaticShareButtonClick" />
    </>
  );
};

export default FundraisingCTA;
